<template>
  <b-section-loader :loading="$loading.isLoading('initDocumentAgreement')">
    <v-card v-if="isInitialized" id="document-single-page" border>
      <v-card-text>
        <div class="d-flex align-center justify-space-between ga-3 mb-3">
          <div class="d-flex align-center ga-3">
            <div class="icon--blue">
              <v-icon icon="mdi-file-document-outline" size="23"></v-icon>
            </div>

            <div>
              <div class="font-weight-bold font-size-18">
                {{ documentAgreementSource.name }}
              </div>
              <div class="d-flex align-center ga-3">
                <span class="text-disabled">
                  {{
                    new CustomDate(
                      documentAgreementSource.created_at
                    ).toString()
                  }}
                </span>
                <v-chip
                  :color="getStatusColor(documentAgreementSource.statusId)"
                  rounded="pill"
                  density="compact">
                  <b>{{ documentAgreementSource.status.name }}</b>
                </v-chip>
              </div>
            </div>
          </div>

          <div class="d-flex align-center ga-2">
            <actions></actions>

            <agreement></agreement>
          </div>
        </div>

        <tabs class="mb-5"></tabs>

        <router-view></router-view>
      </v-card-text>
    </v-card>
  </b-section-loader>
</template>

<script lang="ts">
import { CustomDate } from 'best-modules/utils'
import { initDocumentAgreement } from './documentAgreement'
import Agreement from './components/Agreement.vue'
import Actions from './components/actions/Actions.vue'
import Tabs from './components/Tabs.vue'
import { initComments } from '@/components/comments/v2'
import { ENTITY_TYPE } from '@/utils/constants'
import { BSectionLoader } from 'best-modules/components'

export default {
  name: 'DocumentAgreementSingleV2',
  components: {
    Actions,
    Agreement,
    Tabs,
    BSectionLoader,
  },
  setup() {
    const { isInitialized, documentAgreementSource, documentAgreementId } =
      initDocumentAgreement()
    initComments({
      entityId: documentAgreementId.value,
      entityTypeId: ENTITY_TYPE.DOCUMENT_AGREEMENT,
    })

    const getStatusColor = (statusId: number): string => {
      switch (statusId) {
        case 1:
          return 'black'
        case 2:
          return 'warning'
        case 3:
          return 'info'
        case 4:
          return 'success'
        default:
          return 'gray'
      }
    }

    return {
      documentAgreementSource,
      isInitialized,
      getStatusColor,
      CustomDate,
    }
  },
}
</script>

<style lang="scss" scoped></style>
